module.exports = __webpack_public_path__ + "img/files.8d50ee19.svg";